export const precisionFormats = [0, 1, 2, 3, 4, 5, 6, 7, 8];
export var SeparatorType;
(function (SeparatorType) {
    SeparatorType["Locale"] = "locale";
    SeparatorType["NonePeriod"] = "none_period";
    SeparatorType["NoneComma"] = "none_comma";
    SeparatorType["CommaPeriod"] = "comma_period";
    SeparatorType["PeriodComma"] = "period_comma";
    SeparatorType["SpacePeriod"] = "space_period";
    SeparatorType["SpaceComma"] = "space_comma";
})(SeparatorType || (SeparatorType = {}));
export const supportedBarcodeFormats = [
    { value: 'CODE128', label: 'CODE128' },
    { value: 'upc', label: 'UPC' },
    { value: 'EAN13', label: 'EAN-13' },
    { value: 'EAN8', label: 'EAN-8' },
    { value: 'EAN5', label: 'EAN-5' },
    { value: 'EAN2', label: 'EAN-2' },
    { value: 'CODE39', label: 'CODE39' },
    { value: 'ITF14', label: 'ITF-14' },
    { value: 'MSI', label: 'MSI' },
    { value: 'PHARMACODE', label: 'PHARMACODE' },
    { value: 'CODABAR', label: 'CODABAR' },
];
export const checkboxTypeMap = {
    checked: true,
    x: true,
    yes: true,
    y: true,
    '1': true,
    '[x]': true,
    '☑': true,
    '✅': true,
    '✓': true,
    '✔': true,
    enabled: true,
    on: true,
    done: true,
    true: true,
    unchecked: false,
    '': false,
    no: false,
    n: false,
    '0': false,
    '[]': false,
    '[ ]': false,
    disabled: false,
    off: false,
    false: false,
};
export function isColumnInError(column) {
    var _a;
    return !!((_a = column === null || column === void 0 ? void 0 : column.colOptions) === null || _a === void 0 ? void 0 : _a.error);
}
//# sourceMappingURL=data:application/json;base64,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